import {bookLoaded} from "../actions";

const fetchBooks = async (dispatch) => {
    const response = await fetch("http://localhost:9000/books");
    const booksFromServer = await response.json();
    
    dispatch(bookLoaded(booksFromServer));
}

export default fetchBooks;